/* esm.sh - @radix-ui/react-popper@1.2.8 */
export * from "/*@radix-ui/react-popper@1.2.8/esnext/react-popper.mjs";
